import type {
  BoletoDownloadDto,
  CmsBoletoDto,
  CmsCompanyDto,
  CmsNfeDto,
  CmsProductDto,
  Configuration,
  FaturaDownloadDto,
  GetFaturaAccessDto,
  IRequest,
  SendUpdateUpsellDto,
  SendUpdateUpsellResponseDto,
  SendUpsellCalculationDto,
  SendUpsellCalculationResponseDto,
  SendUpsellDto,
  SendUpsellResponseDto,
  UpsellCompanyDataResponseDto,
} from '../..';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import { GraphQLFleetContractsRequester } from '../fleetContracts';
import { toMultipleContractDto } from '../fleetContracts/toMultipleContractDto';

export class BusinessManagerRequester {
  private requester: Requester;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
  }

  public getMultipleContracts = async (fleetId: string): Promise<any | null> => {
    const fleetContractsRequester = new GraphQLFleetContractsRequester();
    const contracts = await fleetContractsRequester.getFleetContracts(fleetId);
    return toMultipleContractDto(contracts);
  };

  public getCompanyUpsellData = async (companyId: string): Promise<UpsellCompanyDataResponseDto> => {
    const requestData: IRequest = {
      endpoint: 'upsell/company',
      method: HttpMethod.GET,
      params: {
        companyId: companyId,
      },
    };

    const response = await this.requester.request(requestData);
    return response.data;
  };
  public getBoletoTableData = async (companyId: string): Promise<CmsBoletoDto> => {
    const requestData: IRequest = {
      endpoint: 'boleto',
      method: HttpMethod.GET,
      params: {
        id_company: companyId,
      },
    };

    const response = await this.requester.request(requestData);
    return response.data;
  };
  public getCompanyData = async (companyId: string): Promise<CmsCompanyDto> => {
    const requestData: IRequest = {
      endpoint: 'company',
      method: HttpMethod.GET,
      params: {
        idCompany: companyId,
      },
    };

    const response = await this.requester.request(requestData);
    return response.data;
  };
  public getProductData = async (companyId: string): Promise<CmsProductDto> => {
    const requestData: IRequest = {
      endpoint: 'product/company',
      method: HttpMethod.GET,
      params: {
        idCompany: companyId,
      },
    };

    const response = await this.requester.request(requestData);
    return response.data;
  };

  public getNfeTableData = async (companyId: string): Promise<CmsNfeDto> => {
    const requestData: IRequest = {
      endpoint: 'nfe',
      method: HttpMethod.GET,
      params: {
        id_company: companyId,
      },
    };

    const response = await this.requester.request(requestData);
    return response.data;
  };
  public getAccessFatura = async (companyId: string): Promise<GetFaturaAccessDto> => {
    const requestData: IRequest = {
      endpoint: 'fatura/access',
      method: HttpMethod.GET,
      params: {
        id_company: companyId,
      },
    };

    const response = await this.requester.request(requestData);
    return response.data;
  };
  public getBoletoPdfData = async (idDoc: string, companyId: string): Promise<BoletoDownloadDto> => {
    const requestData: IRequest = {
      endpoint: 'boleto/pdf',
      method: HttpMethod.GET,
      params: {
        id_doc: idDoc,
        id_company: companyId,
      },
    };

    const response = await this.requester.request(requestData);
    return response.data;
  };
  public getFaturaDocument = async (idDoc: string, companyId: string): Promise<FaturaDownloadDto> => {
    const requestData: IRequest = {
      endpoint: 'fatura/table',
      method: HttpMethod.GET,
      params: {
        doc_entry: idDoc,
        id_company: companyId,
      },
    };

    const response = await this.requester.request(requestData);
    return response.data;
  };
  public sendUpsell = async (dealBody: SendUpsellDto): Promise<SendUpsellResponseDto> => {
    const requestData: IRequest = {
      endpoint: '/upsell/deal',
      method: HttpMethod.POST,
      body: JSON.stringify(dealBody),
    };

    const response = await this.requester.request(requestData);
    return response.data;
  };

  public getUpsellCalculation = async (calculationBody: SendUpsellCalculationDto): Promise<SendUpsellCalculationResponseDto> => {
    const requestData: IRequest = {
      endpoint: '/upsell/product/calculate',
      method: HttpMethod.POST,
      body: JSON.stringify(calculationBody),
    };

    const response = await this.requester.request(requestData);
    return response.data;
  };

  public updateStageUpsell = async (updateStageBody: SendUpdateUpsellDto): Promise<SendUpdateUpsellResponseDto> => {
    const requestData: IRequest = {
      endpoint: '/upsell/deal/stage',
      method: HttpMethod.PATCH,
      body: JSON.stringify(updateStageBody),
    };

    const response = await this.requester.request(requestData);
    return response.data;
  };

  public getProductList = async (): Promise<any | null> => {
    const requestData: IRequest = {
      endpoint: 'products',
      method: HttpMethod.GET,
      params: {},
    };

    const response = await this.requester.request(requestData);
    return response.data;
  };
}
